import React, { useEffect, useState } from 'react';
import Wrapper from './styles';
import { useCartContext } from '../../context/cart_context';
import { Link } from 'react-router-dom';
import { CartContent, PageHero, StripeCheckout } from '../../components';

const CartPage = () => {
  const { cart } = useCartContext();
  const [cartitems, setCartItems] = useState([]);
  const [isOpenCheckout, setIsOpenCheckout] = useState(false);
  useEffect(() => {
    document.title = 'Mukunda jewelery | Cart';
  }, []);
  useEffect(() => {
    setCartItems(cart);
  }, [cart]);

  const handleCancel = () => {
    setIsOpenCheckout(false);
  };

  if (cartitems?.length < 1) {
    return (
      <Wrapper className='page-100 h-full flex flex-col justify-center items-center'>
        <div className='empty h-full flex flex-col justify-center items-center'>
          <h2 style={{ marginBottom: '5px' }}>Your cart is empty</h2>
          <Link
            to='/collections'
            className='btn'
            style={{ backgroundColor: '#D3A143' }}
          >
            fill it
          </Link>
        </div>
      </Wrapper>
    );
  }

  return (
    <main>
      <Wrapper className='page'>
        {!isOpenCheckout ? (
          <CartContent data={cartitems} isOpenCheckout={setIsOpenCheckout} />
        ) : (
          <StripeCheckout onCancel={handleCancel} />
        )}
      </Wrapper>
    </main>
  );
};

export default CartPage;
